var _g, _g2, _g3, _circle, _rect, _path, _rect2, _path2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceHealthyCooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 137,
    viewBox: "0 0 273 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 95C52.6731 95 67 80.6731 67 63C67 45.3269 52.6731 31 35 31C17.3269 31 3 45.3269 3 63C3 80.6731 17.3269 95 35 95Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 53.1543H51V74.0774C51 75.4368 49.8979 76.5389 48.5385 76.5389H21.4615C20.1021 76.5389 19 75.4368 19 74.0774V53.1543Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 51.9228H19C19 51.9228 26.1634 48.2305 35 48.2305C43.8366 48.2305 51 51.9228 51 51.9228Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 60.5383V55.6152H54.6923C55.372 55.6152 55.9231 56.1663 55.9231 56.846C55.9231 57.5257 55.372 58.0768 54.6923 58.0768H53.4615L51 60.5383Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 60.5383V55.6152H15.3077C14.628 55.6152 14.0769 56.1663 14.0769 56.846C14.0769 57.5257 14.628 58.0768 15.3077 58.0768H16.5385L19 60.5383Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.9996,
    cy: 46.9996,
    r: 2.46154,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 76.8624C37.4612 75.2682 34.9996 73.4614 34.9996 73.4614C34.9996 73.4614 32.5381 75.2682 32.5381 76.8624C32.5381 80.5328 37.4612 80.5328 37.4612 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0774 76.8624C30.0774 75.2682 27.6158 73.4614 27.6158 73.4614C27.6158 73.4614 25.1543 75.2682 25.1543 76.8624C25.1543 80.5328 30.0774 80.5328 30.0774 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8459 76.8624C44.8459 75.2682 42.3844 73.4614 42.3844 73.4614C42.3844 73.4614 39.9229 75.2682 39.9229 76.8624C39.9229 80.5328 44.8459 80.5328 44.8459 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7689,
    cy: 48.2308,
    r: 1.23077,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.6154,
    cy: 42.6925,
    r: 0.615385,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1543 53.1543H44.8466V59.9235C44.8466 60.9431 44.0201 61.7697 43.0005 61.7697V61.7697C41.9808 61.7697 41.1543 60.9431 41.1543 59.9235V53.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6924 53.1543H43.6155V55.6158C43.6155 56.9753 42.5134 58.0774 41.1539 58.0774V58.0774C39.7945 58.0774 38.6924 56.9753 38.6924 55.6158V53.1543Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 95C148.673 95 163 80.6731 163 63C163 45.3269 148.673 31 131 31C113.327 31 99 45.3269 99 63C99 80.6731 113.327 95 131 95Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 53.1543H147V74.0774C147 75.4368 145.898 76.5389 144.538 76.5389H117.462C116.102 76.5389 115 75.4368 115 74.0774V53.1543Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 51.9228H115C115 51.9228 122.163 48.2305 131 48.2305C139.837 48.2305 147 51.9228 147 51.9228Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 60.5383V55.6152H150.692C151.372 55.6152 151.923 56.1663 151.923 56.846C151.923 57.5257 151.372 58.0768 150.692 58.0768H149.462L147 60.5383Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 60.5383V55.6152H111.308C110.628 55.6152 110.077 56.1663 110.077 56.846C110.077 57.5257 110.628 58.0768 111.308 58.0768H112.538L115 60.5383Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 46.9996,
    r: 2.46154,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.461 76.8624C133.461 75.2682 131 73.4614 131 73.4614C131 73.4614 128.538 75.2682 128.538 76.8624C128.538 80.5328 133.461 80.5328 133.461 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.077 76.8624C126.077 75.2682 123.616 73.4614 123.616 73.4614C123.616 73.4614 121.154 75.2682 121.154 76.8624C121.154 80.5328 126.077 80.5328 126.077 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.846 76.8624C140.846 75.2682 138.384 73.4614 138.384 73.4614C138.384 73.4614 135.923 75.2682 135.923 76.8624C135.923 80.5328 140.846 80.5328 140.846 76.8624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.769,
    cy: 48.2308,
    r: 1.23077,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.615,
    cy: 42.6925,
    r: 0.615385,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.154 53.1543H140.847V59.9235C140.847 60.9431 140.02 61.7697 139 61.7697V61.7697C137.981 61.7697 137.154 60.9431 137.154 59.9235V53.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.692 53.1543H139.615V55.6158C139.615 56.9753 138.513 58.0774 137.154 58.0774V58.0774C135.794 58.0774 134.692 56.9753 134.692 55.6158V53.1543Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227 103C249.091 103 267 85.0914 267 63C267 40.9086 249.091 23 227 23C204.909 23 187 40.9086 187 63C187 85.0914 204.909 103 227 103Z",
    fill: "#FFC436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 50.6924H247V76.8462C247 78.5456 245.622 79.9232 243.923 79.9232H210.077C208.378 79.9232 207 78.5456 207 76.8462V50.6924Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 49.1535H207C207 49.1535 215.954 44.5381 227 44.5381C238.046 44.5381 247 49.1535 247 49.1535Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 59.9234V53.7695H251.615C252.465 53.7695 253.154 54.4583 253.154 55.308C253.154 56.1577 252.465 56.8465 251.615 56.8465H250.077L247 59.9234Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 59.9234V53.7695H202.385C201.535 53.7695 200.846 54.4583 200.846 55.308C200.846 56.1577 201.535 56.8465 202.385 56.8465H203.923L207 59.9234Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 42.9998,
    r: 3.07692,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.077 80.3285C230.077 78.3358 227 76.0772 227 76.0772C227 76.0772 223.923 78.3358 223.923 80.3285C223.923 84.9165 230.077 84.9165 230.077 80.3285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.846 80.3285C220.846 78.3358 217.769 76.0772 217.769 76.0772C217.769 76.0772 214.692 78.3358 214.692 80.3285C214.692 84.9165 220.846 84.9165 220.846 80.3285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.308 80.3285C239.308 78.3358 236.231 76.0772 236.231 76.0772C236.231 76.0772 233.154 78.3358 233.154 80.3285C233.154 84.9165 239.308 84.9165 239.308 80.3285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.461,
    cy: 44.5385,
    r: 1.53846,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.769,
    cy: 37.6149,
    r: 0.769231,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.692 50.6924H239.308V59.1539C239.308 60.4284 238.275 61.4616 237 61.4616V61.4616C235.726 61.4616 234.692 60.4284 234.692 59.1539V50.6924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.615 50.6924H237.769V53.7693C237.769 55.4686 236.391 56.8462 234.692 56.8462V56.8462C232.993 56.8462 231.615 55.4686 231.615 53.7693V50.6924Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 93L159.5 97L166.5 89",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 93L63.5 97L70.5 89",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 17,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 134,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253 119.5L260.5 130.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198 20.5L190.5 10.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261 16L266.5 6.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 112.5L188.5 121.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 23,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceHealthyCooking);
export default __webpack_public_path__ + "static/media/persistence-healthy-cooking.a54d5fb9989d6f3f2109a9c79f3fe931.svg";
export { ForwardRef as ReactComponent };